export enum ColumnField {
  EntryID = 'EntryID',
  DiseaseState = 'DiseaseState',
  Category = 'Category',
  TableDefinition = 'TableDefinition',
  Item = 'Item',
  MinimumClearance = 'MinimumClearance',
  MaximumClearance = 'MaximumClearance',
  DrugInteraction = 'DrugInteraction',
  Inclusion = 'Inclusion',
  Exclusion = 'Exclusion',
  Rationale = 'Rationale',
  Recommendation = 'Recommendation',
  RecommendationLineTwo = 'RecommendationLineTwo',
  ShortName = 'ShortTableName',
  SearchTerms = 'SearchTerms',
}
export const columns = [
  'EntryID',
  'DiseaseState',
  'Category',
  'TableDefinition',
  'Item',
  'MinimumClearance',
  'MaximumClearance',
  'DrugInteraction',
  'Inclusion',
  'Exclusion',
  'Rationale',
  'Recommendation',
  'RecommendationLineTwo',
  'ShortTableName',
  'SearchTerms',
] as ColumnField[];
